import { 
    Dialog,
    DialogActions,
    DialogContent,
} from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import styled, { css } from 'styled-components';
import colors from '../../styles/settings/colors';
import fontSize from '../../styles/settings/fontSize';

export const DialogModal = styled(Dialog)`
  &.dialog-parent {
    .MuiDialog-paperWidthSm {
      max-width: fit-content;
      max-height: 100%;
      ${(props) =>
        !props.htmlText &&
        css`
          width: 500px !important;
          ${(props) =>
            props.widthContainer > 0 &&
            css`
              width: ${props.widthContainer}px;
              max-width: ${props.widthContainer + 0.1}px!important;
            `}
        `}
    }
  }
`;

export const AnchorOption = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  > div {
    align-items: center;
    border: 1px solid ${colors.white};
    display: flex;
    justify-content: center;
    width: calc(50% - 4px);
    &.active {
      border: 1px solid #f44336;
    }
    &:hover {
      border: 1px solid #f44336;
    }
    &.capittale {
      width: 100%;
    }
    img {
      height: 100px;
      padding: 8px;
      width: 90%;
      max-width: 100%;
      max-height: 120px;
    }
  }
`;

export const Title = styled(DialogTitle)`
  align-items: center;
  background: ${(props) => props.bgColor || colors.sanMarino};
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: ${(props) => (props.heightTitle ? 0 : '2px 0')}!important;

  h2 {
    color: ${(props) => props.color || '#fff'};
    display: block;
    font-size: ${(props) => (props.fontTitle > 0 ? props.fontTitle : 14)}px;
    font-weight: bold;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    text-align: center;
  }
`;

// export const BodyText = styled(DialogContent)`
//   background: ${(props) => props.bgColor || '#fff'};

//   p {
//     align-items: center;
//     color: ${(props) => props.color || '#000'};
//     display: flex;
//     justify-content: center;
//     text-align: center;
//   }
// `;

export const DialogContainer = styled.div`
  background: ${(props) => props.widhtContainer || 'auto'};
  max-height: 100%;
  padding: 8px;
  ${(props) =>
    props.htmlText &&
    css`
      width: fit-content;
  `}
  .MuiDialog-paperScrollPaper {
    max-height: 100%;
  }
  .margin-container {
    border: 1px solid ${(props) => props.borderColor || colors.sanMarino};
    .MuiDialog-paperScrollPaper {
      max-height: 100%;
    }
    .MuiDialogTitle-root {
      padding: 2px 0;
    }

    .MuiDialogContent-root {
        max-height: 450px;
    }
  }
`;

export const BodyText = styled(DialogContent)`
  background: ${(props) => props.bgColor || '#fff'};
  height: ${(props) => props.height || '#fff'};
  display: flex;
  justify-content: center;

  p {
    align-items: center;
    color: ${(props) => props.color || '#000'};
    font-size: ${(props) =>
      props.messageFontSize ? `${props.messageFontSize}px` : fontSize.button};
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 0;
  }
`;

export const DialogActionsMessage = styled(DialogActions)`
  background: ${(props) => props.backgroundColor || '#fff'};
  justify-content: center !important;
  border-top: 2px solid #222d64;
`;

export const DialogHtmlDiv = styled.div`
  table {
    white-space:nowrap;
  }
`;
